import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';
import { paths } from '../../../../routing/path';

export const MarketplaceDashboardMenuItem = () => (
    <LeftMenuItem
        icon="pe-7s-plugin"
        label="Marketplace Dashboard"
        to={`${paths.venues.connect.opportunities}?tab=dashboard`}
        flagCode={NotificationFlagsCategories.MpCode}
        trackingAction="Marketplace Opportunities"
        gtmCategory="Marketplace Opportunities"
    />
);
